export const CLIENT_MEMBER_LIST_CHANGED = 'CLIENT/MEMBER_LIST_CHANGED';
export const CLIENT_INVITEE_LIST_CHANGED = 'CLIENT/INVITEE_LIST_CHANGED';
export const CLIENT_SUBSCRIPTION_CHANGED = 'CLIENT/CLIENT_SUBSCRIPTION_CHANGED';
export const CLIENT_SET_SUBSCRIPTION_LOADING = 'CLIENT/CLIENT_SET_SUBSCRIPTION_LOADING';
